export default function AutoFills() {
  return <div> fills</div>
}
